<template>
  <div>
    <profile-form
      :create="create"
      :view="view"
      :change="change"
      @close="$router.push('/admin/profile/list')"
      @list="$router.push('/admin/profile/list')"
      @change="id=> $router.push('/admin/profile/change?id=' + id)"
      @view="id=> $router.push('/admin/profile/view?id=' + id)"
    />
  </div>
</template>
<script>

import ProfileForm from "@/views/admin/components/Profile-form.vue"

export default {
  components: { ProfileForm },
  props: ['create', 'change', 'view'],
  data: () => ({}),
}
</script>

<style scoped>

</style>
